import React from 'react'

import { TPaymentCategory } from '../../../../common/validations/paymentCategory'
import { Contract } from '../../../../common/validations'

import { useAPIGetContractPaymentCategoriesSuspense } from 'api/apiHooks/useAPIGetContractPaymentCategories'
import { useAPIGetContractSuspense } from 'api/apiHooks/useAPIGetContract'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

interface Data {
  paymentCategories: TPaymentCategory[]
  contract: Contract
}

export const DataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: paymentCategories } =
    useAPIGetContractPaymentCategoriesSuspense(currentContractId)
  const { data: contract } = useAPIGetContractSuspense(currentContractId)

  return children({ paymentCategories, contract })
}
